import { useTranslation } from 'react-i18next';

import { GamepadLayoutType, JoystickInputs } from '@/providers';

import { gamepadColors } from './gamepadIllustration/gamePadIllustration.colors.ts';
import { getActionForInput } from './gamepadIllustration/gamepadillustration.helpFunctions.ts';
import { PositionedLabelBox } from './gamepadIllustration/PositionedLabelBox.tsx';
import { StyledText } from './gamepadIllustration/StyledText.tsx';

type GamepadIllustrationProps = {
  gamepadLayout: GamepadLayoutType;
};

export const GamepadIllustration = ({ gamepadLayout }: GamepadIllustrationProps) => {
  const { t } = useTranslation(['landingPage']);

  return (
    <svg
      version='1.1'
      height={'500'}
      width={'800'}
      viewBox='200 50 1600 900'
      id='svg2'
      style={{ overflow: 'visible' }}
    >
      {/* Main body */}
      <defs id='defs588'></defs>
      <g id='layer1'>
        <path
          d='m 1151.385,208.637 c -1.436,-13.385 -3.273,-17.921 -8.954,-23.335 -6.74,-6.424 -13.315,-8.98 -30.227,-10.137 -52.217,-3.571 -157.845,-4.476 -214.213,-1.176 -20.757,1.215 -24.229,-0.813 -34.342,7.203 -7.226,5.727 -9.369,11.571 -11.81,22.425 -4.682,20.825 -7.187,46.583 -7.187,46.583 h 308.425 c 10e-4,0 0.411,-21.941 -1.692,-41.563 z'
          id='path8'
        />

        <path
          d='m 1149.158,210.372 c -1.414,-13.189 -3.226,-17.659 -8.823,-22.994 -6.642,-6.33 -13.121,-8.85 -29.785,-9.989 -51.454,-3.519 -155.541,-4.41 -211.087,-1.158 -20.454,1.197 -23.875,-0.801 -33.841,7.098 -7.12,5.644 -9.232,11.402 -11.637,22.098 -4.613,20.521 -7.082,45.903 -7.082,45.903 h 303.924 c 0,-0.001 0.404,-21.622 -1.669,-40.958 z'
          id='path14'
          style={{ fill: gamepadColors.bodyFill }}
        />

        <path
          d='M 1053.73,190.245 H 947.142 c -5.523,0 -10,5.39 -10,12.038 v 7.49 c 0,6.648 4.477,12.038 10,12.038 h 106.589 c 5.522,0 10,-5.39 10,-12.038 v -7.49 c -10e-4,-6.648 -4.478,-12.038 -10.001,-12.038 z'
          id='path20'
        />

        <rect width='297.069' height='1' x='853.07098' y='204.862' id='rect26' />

        <path
          d='m 1052.511,191.583 h -104.15 c -5.396,0 -9.771,4.933 -9.771,11.018 v 6.855 c 0,6.085 4.375,11.018 9.771,11.018 h 104.149 c 5.396,0 9.771,-4.933 9.771,-11.018 v -6.855 c 0,-6.085 -4.374,-11.018 -9.77,-11.018 z'
          id='path32'
          style={{ fill: gamepadColors.bodyFill }}
        />

        <path
          d='m 1541.95,465.9 c 0,0 -45.682,-136.815 -71.429,-174.57 -34.014,-49.878 -85.436,-106.057 -104.71,-113.992 -19.274,-7.935 -81.633,-9.301 -97.506,-2.5 -15.872,6.802 -67.66,53.145 -107.343,64.48 -39.683,11.335 -272.074,5.668 -303.82,1.134 -31.746,-4.534 -47.753,-5.435 -74.964,-23.572 -27.211,-18.137 -40.781,-40.408 -49.852,-44.942 -9.069,-4.534 -75.498,-3.9 -92.505,2.9 -17.007,6.802 -73.429,60.68 -115.379,129.827 -41.95,69.148 -86.697,221.056 -90.971,256.456 -7.937,65.748 -4.134,119.361 -2.134,130.361 2,11 16.959,86.645 72.929,110.19 72.516,30.507 175.672,-32.14 249.496,-61.058 76.927,-30.134 95.033,-27.595 148.73,-27.595 106.576,0 98.615,-1.133 205.216,-1.133 108.843,0 199.412,57.313 249.299,76.583 49.887,19.27 86.436,33.106 134.055,2.5 47.619,-30.606 66.76,-89.285 73.563,-148.231 C 1571.428,583.792 1541.95,465.9 1541.95,465.9 z'
          id='path44'
          style={{
            fill: gamepadColors.bodyFill,
            stroke: gamepadColors.stroke,
            strokeWidth: 5,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: 'none',
          }}
        />

        {/* D-Pad ellipses */}
        <ellipse
          cx='660.89398'
          cy='471.73999'
          rx='132.164'
          ry='107.348'
          id='ellipse50'
          style={{ fill: gamepadColors.bodyAccentLight }}
        />
        <ellipse
          cx='660.89398'
          cy='471.73999'
          rx='127.415'
          ry='103.491'
          id='ellipse56'
          style={{ fill: gamepadColors.bodyFill }}
        />

        {/* Right stick ellipses */}
        <ellipse
          cx='1163.479'
          cy='633.14697'
          rx='121.673'
          ry='90.323997'
          id='ellipse62'
          style={{ fill: gamepadColors.bodyAccentLight }}
        />
        <ellipse
          cx='1163.479'
          cy='633.14801'
          rx='117.301'
          ry='87.079002'
          id='ellipse68'
          style={{ fill: gamepadColors.bodyFill }}
        />
        {/* Left stick ellipses */}
        <ellipse
          cx='825.89398'
          cy='631.73999'
          rx='121.673'
          ry='90.323997'
          id='ellipse50b'
          style={{ fill: gamepadColors.bodyAccentLight }}
        />
        <ellipse
          cx='825.89398'
          cy='631.73999'
          rx='117.301'
          ry='87.079002'
          id='ellipse56b'
          style={{ fill: gamepadColors.bodyFill }}
        />

        {/* D-Pad base */}
        <ellipse cx='659.29901' cy='486.14001' rx='112.28' ry='92.953003' id='ellipse86' />
        <ellipse
          cx='659.29901'
          cy='486.14001'
          rx='108.246'
          ry='89.612999'
          id='ellipse92'
          style={{ fill: gamepadColors.bodyFill, stroke: gamepadColors.stroke, strokeWidth: 2 }}
        />

        {/* Right stick details */}
        <ellipse cx='1161.724' cy='649.54102' rx='83.491997' ry='60.362999' id='ellipse98' />
        <ellipse
          cx='1161.724'
          cy='649.53998'
          rx='81.133003'
          ry='58.657001'
          id='ellipse104'
          style={{ fill: gamepadColors.innerMidGray }}
        />
        <ellipse cx='1163.266' cy='683.54797' rx='74.830002' ry='60.362999' id='ellipse110' />
        <ellipse
          cx='1163.266'
          cy='683.54797'
          rx='71.107002'
          ry='57.360001'
          id='ellipse116'
          style={{ fill: gamepadColors.innerDarkGray }}
        />
        <ellipse
          cx='1165.399'
          cy='688.94897'
          rx='45.897999'
          ry='37.025002'
          id='ellipse122'
          style={{ fill: gamepadColors.bodyAccentLight }}
        />

        {/* Left stick details */}
        <ellipse cx='824.724' cy='649.54102' rx='83.491997' ry='60.362999' id='ellipse128' />
        <ellipse
          cx='824.724'
          cy='649.53998'
          rx='81.133003'
          ry='58.657001'
          id='ellipse134'
          style={{ fill: gamepadColors.innerMidGray }}
        />
        <ellipse cx='826.266' cy='683.54797' rx='74.830002' ry='60.362999' id='ellipse140' />
        <ellipse
          cx='826.266'
          cy='683.54797'
          rx='71.107002'
          ry='57.360001'
          id='ellipse146'
          style={{ fill: gamepadColors.innerDarkGray }}
        />
        <ellipse
          cx='828.399'
          cy='688.94897'
          rx='45.897999'
          ry='37.025002'
          id='ellipse148'
          style={{ fill: gamepadColors.bodyAccentLight }}
        />

        {/* Left stick dots */}
        <circle cx='826.908' cy='649.42999' r='4.0570002' id='circle164ls' />
        <circle cx='826.908' cy='727.047' r='4.0570002' id='circle170ls' />
        <circle cx='877.928' cy='691.64001' r='4.0570002' id='circle176ls' />
        <circle cx='779.2889' cy='691.64001' r='4.0570002' id='circle182ls' />
        <circle cx='826.908' cy='691.64001' r='7' id='circle-center-ls' />

        {/* Right stick dots */}
        <circle cx='1163.908' cy='649.42999' r='4.0570002' id='circle164' />
        <circle cx='1163.908' cy='727.047' r='4.0570002' id='circle170' />
        <circle cx='1214.928' cy='691.64001' r='4.0570002' id='circle176' />
        <circle cx='1116.2889' cy='691.64001' r='4.0570002' id='circle182' />
        <circle cx='1163.908' cy='691.64001' r='7' id='circle-center-rs' />
        {/* D-Pad details */}
        <ellipse cx='661.08197' cy='488.099' rx='93.945' ry='77.369003' id='ellipse128dp' />
        <ellipse
          cx='661.08197'
          cy='488.09698'
          rx='91.527'
          ry='75.376999'
          id='ellipse134dp'
          style={{ fill: gamepadColors.innerDarkGray }}
        />
        <ellipse cx='658.979' cy='497.58801' rx='87.538002' ry='70.967003' id='ellipse140dp' />
        <ellipse
          cx='658.979'
          cy='497.58899'
          rx='84.737999'
          ry='68.697998'
          id='ellipse146dp'
          style={{ fill: gamepadColors.innerDarkGray }}
        />

        {/* D-Pad cross shape */}
        <path
          d='m 743.091,477.662 c 0,0 -29.34,-0.686 -41.231,-13.424 -11.892,-12.739 -11.401,-33.105 -11.401,-33.105 0,0 -16.461,-4.181 -31.472,-4.598 -15.558,-0.432 -30.371,4.613 -30.371,4.613 0,0 1.699,21.69 -10.193,34.43 -11.892,12.738 -42.455,10.893 -42.455,10.893 0,0 -4.113,10.239 -4.113,20.857 0,11.433 4.8,23.646 4.8,23.646 0,0 30.041,-2.025 41.083,9.015 11.043,11.04 9.851,33.76 9.851,33.76 0,0 17.824,4.8 34.156,4.8 16.789,0 34.154,-6.857 34.154,-6.857 0,0 -2.696,-10.635 10.045,-29.318 12.741,-18.683 37.671,-17.017 37.671,-17.017 0,0 2.263,-8.428 2.472,-18.036 0.214,-9.921 -2.996,-19.659 -2.996,-19.659 z'
          id='path152'
        />
        <path
          d='m 740.756,478.214 c 0,0 -28.526,-0.667 -40.088,-13.052 -11.562,-12.386 -11.084,-32.187 -11.084,-32.187 0,0 -16.004,-4.064 -30.598,-4.47 -15.127,-0.42 -29.528,4.485 -29.528,4.485 0,0 1.651,21.088 -9.91,33.474 -11.562,12.385 -41.276,10.59 -41.276,10.59 0,0 -4,9.955 -4,20.278 0,11.115 4.667,22.99 4.667,22.99 0,0 29.207,-1.97 39.942,8.765 10.736,10.733 9.577,32.822 9.577,32.822 0,0 17.33,4.666 33.209,4.666 16.322,0 33.206,-6.666 33.206,-6.666 0,0 -2.622,-10.34 9.766,-28.504 12.387,-18.165 36.624,-16.545 36.624,-16.545 0,0 2.2,-8.194 2.403,-17.535 0.21,-9.643 -2.91,-19.111 -2.91,-19.111 z'
          id='path158'
          style={{ fill: gamepadColors.bodyFill }}
        />

        {/* Face buttons */}
        <path
          d='m 1404.198,394.45499 c 0,20.88796 -20.0428,37.821 -44.767,37.821 -24.7241,0 -44.767,-16.93304 -44.767,-37.821 0,-20.88796 20.0429,-37.821 44.767,-37.821 24.7242,0 44.767,16.93304 44.767,37.821 z'
          transform='matrix(0.9811,-0.1937,0.1937,0.9811,-50.6621,270.8244)'
          id='ellipse248'
          style={{
            fill: gamepadColors.buttonYellow,
            stroke: gamepadColors.stroke,
            strokeWidth: 0,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: 'none',
          }}
        />

        <path
          d='m 1398.453,535.242 c -3.666,-19.884 -26.784,-32.626 -51.637,-28.459 -24.853,4.167 -42.027,23.663 -38.362,43.547 3.666,19.884 26.784,32.626 51.637,28.459 24.852,-4.166 42.028,-23.663 38.362,-43.547 z'
          id='path254'
          style={{
            fill: gamepadColors.buttonGreen,
            stroke: gamepadColors.stroke,
            strokeWidth: 0,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: 'none',
          }}
        />

        <path
          d='m 1300.955,469.078 c -1.63,-19.144 -21.928,-33.294 -45.336,-31.606 -23.408,1.688 -41.063,18.576 -39.432,37.72 1.631,19.144 21.929,33.294 45.336,31.606 23.409,-1.689 41.063,-18.576 39.432,-37.72 z'
          id='path260'
          style={{
            fill: gamepadColors.buttonBlue,
            stroke: gamepadColors.stroke,
            strokeWidth: 0,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: 'none',
          }}
        />

        <path
          d='m 1489.496,448.063 c -5.94,-17.563 -29.05,-25.398 -51.616,-17.501 -22.566,7.896 -36.044,28.536 -30.104,46.099 5.94,17.563 29.05,25.397 51.616,17.501 22.567,-7.898 36.046,-28.537 30.104,-46.099 z'
          id='path266'
          style={{
            fill: gamepadColors.buttonRed,
            fillOpacity: 1,
            stroke: gamepadColors.stroke,
            strokeWidth: 0,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: 'none',
          }}
        />

        {/* Center area details */}
        <path
          d='M 1079.507,266.107 H 927.296 c -6.34,0 -11.479,0.038 -11.479,6.377 0,6.338 5.14,16.578 11.479,16.578 h 152.211 c 6.34,0 11.479,-10.24 11.479,-16.578 0,-6.338 -5.139,-6.377 -11.479,-6.377 z'
          id='path272'
        />

        <path
          d='m 888.198,267.854 -16.7,-3.216 c -4.15,-0.799 -8.162,1.917 -8.962,6.067 -0.799,4.149 1.918,8.161 6.068,8.96 l 16.7,3.216 c 4.15,0.799 8.162,-1.918 8.962,-6.067 0.799,-4.15 -1.917,-8.162 -6.068,-8.96 z'
          id='path278'
        />

        <path
          d='m 886.238,269.034 -13.359,-2.571 c -3.319,-0.64 -6.529,1.533 -7.169,4.853 -0.64,3.32 1.534,6.529 4.854,7.168 l 13.358,2.572 c 3.32,0.64 6.53,-1.533 7.17,-4.854 0.639,-3.319 -1.533,-6.528 -4.854,-7.168 z'
          id='path284'
          style={{ fill: gamepadColors.bodyFill }}
        />

        <path
          d='m 1147.108,257.181 c -5.836,1.444 -277.497,4.142 -296.769,-0.851 -49.543,-12.832 -93.561,-25.355 -93.561,-25.355 v 2.258 c 0,0 30.28,10.184 92.71,26.499 24.125,6.305 276.134,5.101 297.619,0.85 58.403,-11.555 104.167,-27.206 104.167,-27.206 v -3.4 c 0,-0.001 -47.31,13.137 -104.166,27.205 z'
          id='path290'
          style={{ fill: gamepadColors.bodyPanelGray }}
        />

        <path
          d='m 1254.031,285.813 c 0,0 -68.557,37.949 -121.163,59.091 -5.162,2.075 -67.258,4.26 -131.842,3.664 -64.69,-0.596 -131.872,-3.979 -140.794,-8.285 -46.656,-22.522 -108.234,-57.266 -108.234,-57.266 v 3.17 c 0,0 43.289,26.046 104.938,56.935 11.394,5.709 77.495,7.789 143.724,8.535 62.521,0.703 124.938,-0.289 134.91,-3.998 60.2,-22.388 120.772,-59.741 120.772,-59.741 l -2.311,-2.105 z'
          id='path296'
          style={{ fill: gamepadColors.bodyPanelGray }}
        />

        {/* Left trigger area */}
        <path
          d='m 757.653,231.25 c -7.653,-8.502 -66.403,-0.94 -121.536,7.062 -50.064,7.266 -81.632,21.451 -89.285,29.103 -7.653,7.652 -20.455,41.083 -10.268,42.053 11.404,1.086 54.563,-17.311 104.759,-22.732 58.013,-6.266 106.777,2.487 111.228,-1.072 8.504,-6.804 12.755,-45.912 5.102,-54.414 z'
          id='path302'
        />

        <path
          d='m 754.453,233.818 c -7.384,-7.711 -64.543,-0.376 -117.737,6.88 -48.303,6.59 -79.642,20.945 -87.025,27.885 -7.383,6.94 -21.236,36.719 -11.407,37.599 11.003,0.984 55.026,-18.558 103.456,-23.475 55.973,-5.683 104.45,3.209 108.744,-0.02 8.204,-6.168 11.353,-41.159 3.969,-48.869 z'
          id='path308'
          style={{ fill: gamepadColors.bodyFill, stroke: gamepadColors.stroke, strokeWidth: 2 }}
        />

        {/* Start/Select buttons */}
        <path
          d='m 887.306,455.44 h -24.191 c -12.244,0 -22.169,9.924 -22.169,22.165 0,12.241 9.925,22.165 22.169,22.165 h 24.191 c 12.244,0 22.169,-9.924 22.169,-22.165 0,-12.241 -9.925,-22.165 -22.169,-22.165 z'
          id='path314'
        />

        <path
          d='m 885.918,457.988 h -21.416 c -10.838,0 -19.625,8.785 -19.625,19.622 0,10.836 8.787,19.621 19.625,19.621 h 21.416 c 10.839,0 19.625,-8.785 19.625,-19.621 0,-10.837 -8.786,-19.622 -19.625,-19.622 z'
          id='path320'
          style={{ fill: gamepadColors.bodyFill, stroke: gamepadColors.stroke, strokeWidth: 2 }}
        />

        {/* Left trigger top */}
        <path
          d='m 717.401,118.461 c -2.66,-7.82 -65.854,-3.199 -71.749,4.137 -3.636,5.803 -0.385,22.04 -3.439,42.851 -4.834,32.925 -12.579,62.965 -12.579,62.965 l 76.318,-6.011 c 0,0 11.143,-15.015 12.757,-34.373 2.06,-24.692 3.374,-55.806 -1.308,-69.569 z'
          id='path326'
        />

        <path
          d='m 715.494,120.847 c -2.54,-7.468 -62.883,-3.055 -68.513,3.95 -3.472,5.541 -0.367,21.046 -3.285,40.918 -4.615,31.44 -12.011,60.126 -12.011,60.126 l 74.045,-4.97 c 0,0 9.41,-14.661 10.941,-32.748 2.008,-23.708 3.347,-53.977 -1.177,-67.276 z'
          id='path332'
          style={{ fill: gamepadColors.bodyFill, stroke: gamepadColors.stroke, strokeWidth: 2 }}
        />

        <path
          d='m 710.209,120.55345 c -0.80537,2.1069 -0.4558,34.06424 -1.93622,56.89409 -1.48042,22.82985 -5.74056,43.63985 -5.74056,43.63985 l 3.20433,-0.20384 c 0,0 4.9504,-30.36105 5.50265,-43.08518 0.55225,-12.72413 1.4776,-54.2043 2.3758,-55.94592 0.89819,-1.74162 1.35741,-1.78693 1.35741,-1.78693 0,0 -0.57393,-0.5527 -1.36153,-0.8981 -0.7876,-0.3454 -1.91395,-0.69094 -1.91395,-0.69094 0,0 -0.68256,-0.0299 -1.48793,2.07697 z'
          id='path338'
          style={{ fill: gamepadColors.smallDetailGray }}
        />

        {/* Right trigger area */}
        <path
          d='m 1459.971,267.414 c -7.653,-7.651 -39.221,-21.837 -89.285,-29.103 -55.133,-8.002 -113.883,-15.563 -121.536,-7.062 -7.653,8.501 -3.401,47.61 5.103,54.412 4.45,3.56 53.214,-5.193 111.228,1.072 50.195,5.422 93.354,23.818 104.759,22.732 10.186,-0.968 -2.616,-34.399 -10.269,-42.051 z'
          id='path344'
        />

        <path
          d='m 1457.112,268.583 c -7.384,-6.939 -38.723,-21.295 -87.025,-27.885 -53.194,-7.256 -110.354,-14.591 -117.737,-6.88 -7.384,7.71 -4.234,42.7 3.97,48.869 4.294,3.229 52.771,-5.663 108.744,0.02 48.43,4.917 92.453,24.459 103.456,23.475 9.829,-0.88 -4.024,-30.66 -11.408,-37.599 z'
          id='path350'
          style={{ fill: gamepadColors.bodyFill, stroke: gamepadColors.stroke, strokeWidth: 2 }}
        />

        <path
          d='m 1143.688,455.44 h -24.191 c -12.244,0 -22.169,9.924 -22.169,22.165 0,12.241 9.925,22.165 22.169,22.165 h 24.191 c 12.243,0 22.169,-9.924 22.169,-22.165 0,-12.241 -9.925,-22.165 -22.169,-22.165 z'
          id='path356'
        />

        <path
          d='m 1142.301,457.988 h -21.416 c -10.839,0 -19.625,8.785 -19.625,19.622 0,10.836 8.786,19.621 19.625,19.621 h 21.416 c 10.838,0 19.625,-8.785 19.625,-19.621 0,-10.837 -8.787,-19.622 -19.625,-19.622 z'
          id='path362'
          style={{ fill: gamepadColors.bodyFill, stroke: gamepadColors.stroke, strokeWidth: 2 }}
        />

        <path
          d='m 1364.59,165.448 c -3.055,-20.811 0.196,-37.048 -3.439,-42.851 -5.896,-7.336 -69.089,-11.957 -71.749,-4.137 -4.682,13.763 -3.367,44.877 -1.308,69.568 1.614,19.358 12.756,34.373 12.756,34.373 l 76.319,6.011 c 0,0.001 -7.745,-30.039 -12.579,-62.964 z'
          id='path368'
        />

        <path
          d='m 1363.105,165.715 c -2.917,-19.872 0.188,-35.377 -3.284,-40.918 -5.63,-7.005 -65.973,-11.418 -68.513,-3.95 -4.524,13.3 -3.185,43.568 -1.178,67.276 1.53,18.087 10.941,32.748 10.941,32.748 l 74.045,4.97 c 10e-4,0 -7.394,-28.686 -12.011,-60.126 z'
          id='path374'
          style={{ fill: gamepadColors.bodyFill, stroke: gamepadColors.stroke, strokeWidth: 2 }}
        />

        {/* Center button details */}
        <ellipse
          cx='1002.551'
          cy='475.25299'
          rx='70.523003'
          ry='57.227001'
          id='ellipse386'
          style={{ fill: gamepadColors.buttonLime }}
        />

        <rect
          width='7.125'
          height='120.065'
          x='998.43903'
          y='417.63101'
          id='rect392'
          style={{ fill: gamepadColors.bodyFill }}
        />

        <rect
          width='150.004'
          height='7.125'
          x='927.008'
          y='474.09201'
          id='rect398'
          style={{ fill: gamepadColors.bodyFill }}
        />

        <ellipse cx='1002.551' cy='476.103' rx='58.674' ry='47.610001' id='ellipse404' />

        <ellipse
          cx='1002.551'
          cy='476.103'
          rx='55.278'
          ry='44.855'
          id='ellipse410'
          style={{ fill: gamepadColors.innerMetalGray }}
        />

        {/* Button letters */}
        <g
          id='A'
          style={{
            fill: gamepadColors.letterA,
            fillOpacity: 1,
            stroke: gamepadColors.stroke,
            strokeWidth: 0.5,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: 'none',
          }}
        >
          <g
            transform='matrix(1.3514,0,0,1,1327.2598,560.4512)'
            style={{
              fontSize: '53.72299957px',
              fill: gamepadColors.letterA,
              fillOpacity: 1,
              stroke: gamepadColors.stroke,
              strokeWidth: 0.43010852,
              strokeMiterlimit: 4,
              strokeOpacity: 1,
              strokeDasharray: 'none',
              fontFamily: 'Arial-BoldMT',
            }}
          >
            <path
              d='m -0.0786958,0 14.7685788,-38.456014 5.482474,0 L 35.911517,0 30.11426,0 l -4.485661,-11.646978 -16.0801752,0 L 5.3250825,0 z m 11.0961078,-15.791624 13.037271,0 -4.013486,-10.650165 c -1.224176,-3.235242 -2.133548,-5.893409 -2.728121,-7.974508 -0.48968,2.465834 -1.180453,4.914145 -2.072323,7.344942 z'
              style={{
                fontSize: '53.72299957px',
                fill: gamepadColors.letterA,
                fillOpacity: 1,
                stroke: gamepadColors.stroke,
                strokeWidth: 0.43010852,
                strokeMiterlimit: 4,
                strokeOpacity: 1,
                strokeDasharray: 'none',
                fontFamily: 'Arial-BoldMT',
              }}
            />
          </g>
        </g>

        <g
          id='B'
          style={{
            fill: gamepadColors.letterB,
            fillOpacity: 1,
            stroke: gamepadColors.stroke,
            strokeWidth: 0.5,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: 'none',
          }}
        >
          <g
            transform='matrix(1.3514,0,0,1,1425.8994,482.2334)'
            style={{
              fontSize: '53.72299957px',
              fill: gamepadColors.letterB,
              fillOpacity: 1,
              stroke: gamepadColors.stroke,
              strokeWidth: 0.43010852,
              strokeMiterlimit: 4,
              strokeOpacity: 1,
              strokeDasharray: 'none',
              fontFamily: 'Arial-BoldMT',
            }}
          >
            <path
              d='m 3.93479,0 0,-38.456014 14.812966,-0.651042 c 2.936403,-0.129057 5.390805,-0.0015 7.165856,0.776696 1.775001,0.77825 3.261643,1.715758 4.267229,3.333359 1.005527,1.617668 1.508305,3.309626 1.508336,5.075879 -3.1e-5,1.643894 -0.445974,3.191577 -1.337829,4.643052 -0.891914,1.451523 -2.334836,2.883631 -4.136068,3.775495 2.32587,0.68205 4.210362,1.584582 5.460781,3.228431 1.250357,1.643883 1.971901,3.454835 1.971934,5.69328 -3.3e-5,1.801269 -0.476746,3.6059479 -1.23744,5.1536243 -0.760757,1.5476886 -1.700734,2.7412404 -2.819933,3.5806589 -1.119257,0.8394235 -2.619015,1.7337779 -4.306576,2.1622318 -1.687611,0.4284551 -3.853163,0.92744522 -6.300202,1.03330733 z m 5.0889951,-22.297143 8.7009259,-0.651042 c 2.252477,-0.16854 3.969911,-0.539251 4.949258,-0.836568 1.294085,-0.384712 2.365388,-1.283438 3.021211,-2.175347 0.655773,-0.891861 0.983672,-2.011089 0.983698,-3.357688 -2.6e-5,-1.276591 -0.306065,-2.400191 -0.918118,-3.370803 -0.612103,-0.970549 -1.582851,-1.374675 -2.719544,-1.733211 -1.136739,-0.35847 -3.187903,-0.369606 -5.946071,-0.14713 l -8.0713599,0.651042 z m 0,17.7590185 9.9600589,-0.6510417 c 1.641927,-0.107325 2.894401,-0.451828 3.558965,-0.5742485 1.17167,-0.2098505 2.247345,-0.8200259 3.034328,-1.3096939 0.786932,-0.4896565 1.433985,-1.20229 1.941163,-2.1379026 0.507123,-0.9355968 0.857049,-2.1456858 0.857077,-3.3698528 -2.8e-5,-1.433999 -0.463626,-2.549806 -1.198093,-3.607841 -0.73452,-1.058006 -1.849543,-1.540827 -3.152371,-1.969299 -1.302875,-0.428437 -3.2781,-0.423623 -5.723099,-0.252057 l -9.2780289,0.651042 z'
              style={{
                fontSize: '53.72299957px',
                fill: gamepadColors.letterB,
                fillOpacity: 1,
                stroke: gamepadColors.stroke,
                strokeWidth: 0.43010852,
                strokeMiterlimit: 4,
                strokeOpacity: 1,
                strokeDasharray: 'none',
                fontFamily: 'Arial-BoldMT',
              }}
            />
          </g>
        </g>

        <g
          id='Y'
          style={{
            fill: gamepadColors.letterY,
            fillOpacity: 1,
            stroke: gamepadColors.stroke,
            strokeOpacity: 1,
          }}
        >
          <g
            transform='matrix(1.3514,0,0,1,1336.0654,414.2188)'
            style={{
              fontSize: '53.72299957px',
              fill: gamepadColors.letterY,
              fillOpacity: 1,
              stroke: gamepadColors.stroke,
              strokeOpacity: 1,
              fontFamily: 'Arial-BoldMT',
            }}
          >
            <path
              d='m 14.978434,0 0,-16.290031 -14.8210424,-22.165983 6.1907363,0 7.5810291,11.594514 c 1.399021,2.168531 2.701872,4.337036 3.908558,6.50552 1.154186,-2.011093 2.553221,-4.275781 4.197109,-6.794071 l 7.449869,-11.305963 5.928417,0 -15.345681,22.165983 0,16.290031 z'
              style={{
                fontSize: '53.72299957px',
                fill: gamepadColors.letterY,
                fillOpacity: 1,
                stroke: gamepadColors.stroke,
                strokeOpacity: 1,
                fontFamily: 'Arial-BoldMT',
              }}
            />
          </g>
        </g>

        {/* Shoulder button labels */}
        <g id='RB'>
          <g
            transform='matrix(1.3514,0,0,1,1287.4385,262.6719)'
            style={{
              fontSize: '27.70590019px',
              fill: gamepadColors.labelGray,
              fontFamily: 'Arial-BoldMT',
            }}
          >
            <path
              d='m 2.1780517,0 0,-19.832446 8.7933763,0 c 1.767682,2e-5 3.111489,0.178142 4.031425,0.534367 0.919907,0.356263 1.654942,0.985327 2.205108,1.887193 0.550132,0.901902 0.825207,1.898483 0.825225,2.989748 -1.8e-5,1.406954 -0.455469,2.592931 -1.366355,3.557936 -0.91092,0.9650265 -2.317859,1.5783076 -4.220821,1.8398449 0.694438,0.333706 1.22204,0.6628936 1.582808,0.9875638 0.766587,0.7034774 1.492603,1.5828142 2.178051,2.6380129 L 19.656579,0 16.35568,0 13.731196,-4.1261228 C 12.964581,-5.3166054 12.333262,-6.2275081 11.837238,-6.8588337 11.34119,-7.4901455 10.897012,-7.9320686 10.504703,-8.1846043 10.112373,-8.4371236 9.7132893,-8.612991 9.3074508,-8.7122069 9.0098199,-8.7753301 8.5228026,-8.806896 7.8463975,-8.8069048 l -3.0438611,0 0,8.8069048 z m 2.6244847,-11.079654 5.6412896,0 c 1.199495,1.1e-5 2.137454,-0.123998 2.81388,-0.372028 0.6764,-0.248007 1.190474,-0.644835 1.542223,-1.190488 0.35172,-0.545627 0.527587,-1.138616 0.527603,-1.778968 -1.6e-5,-0.937944 -0.340477,-1.709055 -1.021385,-2.313334 -0.680936,-0.604245 -1.756433,-0.906376 -3.226493,-0.906394 l -6.2771176,0 z'
              style={{
                fontSize: '27.70590019px',
                fill: gamepadColors.labelGray,
                fontFamily: 'Arial-BoldMT',
              }}
            />
            <path
              d='m 22.051082,0 0,-19.832446 7.440549,0 c 1.515156,2e-5 2.730444,0.200689 3.645869,0.602008 0.915399,0.401358 1.632397,1.019148 2.150996,1.853373 0.518567,0.83426 0.777859,1.706833 0.777875,2.617721 -1.6e-5,0.847785 -0.229996,1.645953 -0.689942,2.394504 -0.459976,0.748576 -1.154426,1.352838 -2.083354,1.812788 1.199493,0.351745 2.121669,0.9514982 2.766532,1.7992603 0.644831,0.8477796 0.967254,1.8488707 0.967271,3.0032763 -1.7e-5,0.9289461 -0.196176,1.7924999 -0.588479,2.590664 -0.392336,0.7981704 -0.877099,1.4137061 -1.45429,1.8466091 -0.57722,0.43290553 -1.300982,0.75983843 -2.171287,0.98079965 C 31.942491,-0.11048077 30.876013,0 29.613386,0 z m 2.624484,-11.499031 4.288463,0 c 1.163421,1.2e-5 1.997663,-0.07665 2.50273,-0.22998 0.667382,-0.198403 1.170183,-0.527591 1.508402,-0.987564 0.338194,-0.459948 0.507297,-1.037154 0.50731,-1.731619 -1.3e-5,-0.658361 -0.157843,-1.237821 -0.473489,-1.738383 -0.315673,-0.500529 -0.766615,-0.843245 -1.352827,-1.028149 -0.586237,-0.184869 -1.591837,-0.277312 -3.016805,-0.277329 l -3.963784,0 z m 0,9.15864 4.93782,0 c 0.847761,2.4e-6 1.443004,-0.031564 1.785731,-0.094698 0.604251,-0.1082236 1.109306,-0.2886004 1.515167,-0.5411308 0.405835,-0.2525246 0.739532,-0.6200422 1.001092,-1.1025542 0.261532,-0.4825038 0.392306,-1.0394171 0.39232,-1.6707415 -1.4e-5,-0.739539 -0.18941,-1.3821313 -0.568188,-1.9277787 C 33.360703,-8.2229263 32.835356,-8.6062269 32.163465,-8.8271973 31.491549,-9.04815 30.524279,-9.1586308 29.261651,-9.15864 l -4.586085,0 z'
              style={{
                fontSize: '27.70590019px',
                fill: gamepadColors.labelGray,
                fontFamily: 'Arial-BoldMT',
              }}
            />
          </g>
        </g>

        <g id='RT'>
          <g
            transform='matrix(1.3514,0,0,1,1309.9307,215.061)'
            style={{
              fontSize: '27.70590019px',
              fill: gamepadColors.labelGray,
              fontFamily: 'Arial-BoldMT',
            }}
          >
            <path
              d='m 2.1780517,0 0,-19.832446 8.7933763,0 c 1.767682,2e-5 3.111489,0.178142 4.031425,0.534367 0.919907,0.356263 1.654942,0.985327 2.205108,1.887193 0.550132,0.901902 0.825207,1.898483 0.825225,2.989748 -1.8e-5,1.406954 -0.455469,2.592931 -1.366355,3.557936 -0.91092,0.9650265 -2.317859,1.5783076 -4.220821,1.8398449 0.694438,0.333706 1.22204,0.6628936 1.582808,0.9875638 0.766587,0.7034774 1.492603,1.5828142 2.178051,2.6380129 L 19.656579,0 16.35568,0 13.731196,-4.1261228 C 12.964581,-5.3166054 12.333262,-6.2275081 11.837238,-6.8588337 11.34119,-7.4901455 10.897012,-7.9320686 10.504703,-8.1846043 10.112373,-8.4371236 9.7132893,-8.612991 9.3074508,-8.7122069 9.0098199,-8.7753301 8.5228026,-8.806896 7.8463975,-8.8069048 l -3.0438611,0 0,8.8069048 z m 2.6244847,-11.079654 5.6412896,0 c 1.199495,1.1e-5 2.137454,-0.123998 2.81388,-0.372028 0.6764,-0.248007 1.190474,-0.644835 1.542223,-1.190488 0.35172,-0.545627 0.527587,-1.138616 0.527603,-1.778968 -1.6e-5,-0.937944 -0.340477,-1.709055 -1.021385,-2.313334 -0.680936,-0.604245 -1.756433,-0.906376 -3.226493,-0.906394 l -6.2771176,0 z'
              style={{
                fontSize: '27.70590019px',
                fill: gamepadColors.labelGray,
                fontFamily: 'Arial-BoldMT',
              }}
            />
            <path
              d='m 27.205353,0 0,-17.492055 -6.534155,0 0,-2.340391 15.719852,0 0,2.340391 -6.561212,0 0,17.492055 z'
              style={{
                fontSize: '27.70590019px',
                fill: gamepadColors.labelGray,
                fontFamily: 'Arial-BoldMT',
              }}
            />
          </g>
        </g>

        <g id='LB'>
          <g
            transform='matrix(1.3514,0,0,1,670.4751,262.6719)'
            style={{
              fontSize: '27.70590019px',
              fill: gamepadColors.labelGray,
              fontFamily: 'Arial-BoldMT',
            }}
          >
            <path
              d='m 2.0292407,0 0,-19.832446 2.6244847,0 0,17.492055 9.7674126,0 0,2.340391 z'
              style={{
                fontSize: '27.70590019px',
                fill: gamepadColors.labelGray,
                fontFamily: 'Arial-BoldMT',
              }}
            />
            <path
              d='m 17.451471,0 0,-19.832446 7.440549,0 c 1.515155,2e-5 2.730444,0.200689 3.645869,0.602008 0.915399,0.401358 1.632397,1.019148 2.150995,1.853373 0.518568,0.83426 0.77786,1.706833 0.777876,2.617721 -1.6e-5,0.847785 -0.229997,1.645953 -0.689942,2.394504 -0.459976,0.748576 -1.154427,1.352838 -2.083354,1.812788 1.199492,0.351745 2.121669,0.9514982 2.766532,1.7992603 0.644831,0.8477796 0.967254,1.8488707 0.967271,3.0032763 -1.7e-5,0.9289461 -0.196177,1.7924999 -0.58848,2.590664 -0.392336,0.7981704 -0.877098,1.4137061 -1.454289,1.8466091 -0.577221,0.43290553 -1.300982,0.75983843 -2.171287,0.98079965 C 27.34288,-0.11048077 26.276402,0 25.013774,0 z m 2.624484,-11.499031 4.288462,0 c 1.163422,1.2e-5 1.997664,-0.07665 2.502731,-0.22998 0.667382,-0.198403 1.170182,-0.527591 1.508402,-0.987564 0.338193,-0.459948 0.507297,-1.037154 0.50731,-1.731619 -1.3e-5,-0.658361 -0.157843,-1.237821 -0.47349,-1.738383 -0.315672,-0.500529 -0.766614,-0.843245 -1.352827,-1.028149 -0.586236,-0.184869 -1.591836,-0.277312 -3.016804,-0.277329 l -3.963784,0 z m 0,9.15864 4.937819,0 c 0.847762,2.4e-6 1.443005,-0.031564 1.785732,-0.094698 0.604251,-0.1082236 1.109306,-0.2886004 1.515167,-0.5411308 0.405834,-0.2525246 0.739531,-0.6200422 1.001092,-1.1025542 0.261532,-0.4825038 0.392305,-1.0394171 0.39232,-1.6707415 -1.5e-5,-0.739539 -0.18941,-1.3821313 -0.568188,-1.9277787 C 28.761092,-8.2229263 28.235745,-8.6062269 27.563854,-8.8271973 26.891938,-9.04815 25.924667,-9.1586308 24.662039,-9.15864 l -4.586084,0 z'
              style={{
                fontSize: '27.70590019px',
                fill: gamepadColors.labelGray,
                fontFamily: 'Arial-BoldMT',
              }}
            />
          </g>
        </g>

        <g id='LT'>
          <g
            transform='matrix(1.3514,0,0,1,652.1509,215.061)'
            style={{
              fontSize: '27.70590019px',
              fill: gamepadColors.labelGray,
              fontFamily: 'Arial-BoldMT',
            }}
          >
            <path
              d='m 2.0292407,0 0,-19.832446 2.6244847,0 0,17.492055 9.7674126,0 0,2.340391 z'
              style={{
                fontSize: '27.70590019px',
                fill: gamepadColors.labelGray,
                fontFamily: 'Arial-BoldMT',
              }}
            />
            <path
              d='m 22.605742,0 0,-17.492055 -6.534155,0 0,-2.340391 15.719851,0 0,2.340391 -6.561211,0 0,17.492055 z'
              style={{
                fontSize: '27.70590019px',
                fill: gamepadColors.labelGray,
                fontFamily: 'Arial-BoldMT',
              }}
            />
          </g>
        </g>

        <g
          id='X'
          style={{
            fill: gamepadColors.letterX,
            fillOpacity: 1,
            stroke: gamepadColors.stroke,
            strokeWidth: 0.5,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: 'none',
          }}
        >
          <g
            transform='matrix(1.3514,0,0,1,1234.0254,492.4365)'
            style={{
              fontSize: '53.72299957px',
              fill: gamepadColors.letterX,
              fillOpacity: 1,
              stroke: gamepadColors.stroke,
              strokeWidth: 0.43010852,
              strokeMiterlimit: 4,
              strokeOpacity: 1,
              strokeDasharray: 'none',
              fontFamily: 'Arial-BoldMT',
            }}
          >
            <path
              d='M 0.2360874,0 15.109594,-20.041197 1.9936269,-38.456014 l 6.0595766,0 6.9776945,9.863207 c 1.451484,2.046117 2.483272,3.620031 3.095368,4.721748 0.856891,-1.399012 1.871191,-2.859254 3.042904,-4.380733 l 7.738421,-10.204222 5.534938,0 L 20.933083,-20.329748 35.491806,0 29.196142,0 19.516558,-13.719301 c -0.542145,-0.786944 -1.101759,-1.643853 -1.678843,-2.57073 -0.856927,1.399052 -1.469005,2.360888 -1.836236,2.885513 L 6.3481279,0 z'
              style={{
                fontSize: '53.72299957px',
                fill: gamepadColors.letterX,
                fillOpacity: 1,
                stroke: gamepadColors.stroke,
                strokeWidth: 0.43010852,
                strokeMiterlimit: 4,
                strokeOpacity: 1,
                strokeDasharray: 'none',
                fontFamily: 'Arial-BoldMT',
              }}
            />
          </g>
        </g>

        {/* Center button accents */}
        <polygon
          points='964.982,444.123 964.19,444.758 995.068,477.273 1041.872,507.002 1042.665,506.367 1007.438,467.961 '
          id='polygon440'
          style={{ fill: gamepadColors.buttonLime }}
        />

        <polygon
          points='996.563,467.961 961.335,506.367 962.127,507.002 1008.932,477.273 1039.81,443.758 1039.018,443.123 '
          id='polygon446'
          style={{ fill: gamepadColors.buttonLime }}
        />

        {/* Index lines */}
        <g id='indexLines'>
          <rect
            width='3.401'
            height='74.816002'
            x='1000.425'
            y='400.01199'
            id='rect452'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='49.978001'
            height='3.402'
            x='1118.925'
            y='454.28699'
            transform='matrix(0.5001,-0.866,0.866,0.5001,177.0024,1218.5801)'
            id='rect461'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='3.401'
            height='48.872002'
            x='858.91498'
            y='432.03201'
            transform='matrix(0.8659,-0.5002,0.5002,0.8659,-112.9271,491.6349)'
            id='rect470'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='3.402'
            height='48.873001'
            x='658.23401'
            y='88.557999'
            transform='matrix(0.8661,-0.4998,0.4998,0.8661,31.8675,344.9707)'
            id='rect479'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='49.977001'
            height='3.401'
            x='1323.007'
            y='110.814'
            transform='matrix(0.5001,-0.866,0.866,0.5001,576.4635,1223.5898)'
            id='rect488'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='3.401'
            height='134.896'
            x='877.55103'
            y='137.729'
            id='rect497'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='176.87'
            height='3.4000001'
            x='1371.3149'
            y='257.32199'
            id='rect506'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='135.84642'
            height='3.5381069'
            x='1482.519'
            y='462.5'
            id='rect518'
            fill={gamepadColors.indexStroke}
          />

          <path
            d='m 1313.4969,317.96696 307.5884,60 -0.5961,3.38551 -305.9273,-60 -54.6879,59.8236 0,66.89 -3.401,-1.82292 0,-66.89 z'
            id='rect536'
            fill={gamepadColors.indexStroke}
          />

          <path
            d='m 1510.062,310 3.3784,0 10,235 -3.3808,0.42443 z'
            transform='matrix(0.2113,-0.9774,0.9774,0.2113,767.474,1796.1644)'
            id='rect542'
            fill={gamepadColors.indexStroke}
          />

          <path
            d='m 1377.113,509.12799 246.5952,30 -1.302,3.26481 -246.2932,-30 z'
            transform='matrix(0.9682,-0.2501,0.2501,0.9682,-80.0946,391.2577)'
            id='rect548'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='176.87'
            height='3.4000001'
            x='456.35001'
            y='257.32199'
            id='rect554'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='3.401'
            height='119.83099'
            x='825.396'
            y='745'
            id='rect563'
            fill={gamepadColors.indexStroke}
          />

          <rect
            width='3.401'
            height='119'
            x='1162.132'
            y='745'
            id='rect572'
            fill={gamepadColors.indexStroke}
          />
          <rect
            width='3.401'
            height='350'
            x='1168'
            y='692'
            transform='rotate(-45 1168 700)'
            id='rect590'
            fill={gamepadColors.indexStroke}
          />
          <rect
            width='3.401'
            height='350'
            x='818'
            y='690'
            transform='rotate(45 820 700)'
            id='rect591'
            fill={gamepadColors.indexStroke}
          />
          <rect
            width='240.545'
            height='3.4000001'
            x='408.63599'
            y='505.55603'
            id='rect581'
            fill={gamepadColors.indexStroke}
          />
        </g>
      </g>
      {/* Right trigger detail */}
      <g transform='matrix(-1,0,0,1,2006.2538,-0.15857603)'>
        <path
          d='m 710.209,120.55345 c -0.86687,1.86425 -0.4558,34.06424 -1.93622,56.89409 -1.48042,22.82985 -6.29298,43.78946 -6.29298,43.78946 l 3.21584,-0.18082 c 0,0 5.49131,-30.53368 6.04356,-43.25781 0.55225,-12.72413 1.4776,-54.2043 2.3758,-55.94592 0.89819,-1.74162 0.91038,-1.52103 0.91038,-1.52103 0,0 -0.12573,-0.18116 -0.76754,-0.62625 -0.64182,-0.44509 -2.39923,-1.00873 -2.39923,-1.00873 0,0 -0.28274,-0.007 -1.14961,1.85701 z'
          style={{ fill: gamepadColors.smallDetailGray }}
        />
      </g>
      {/*endregion*/}
      {/* ------- Labels using StyledText ------- */}

      {/* Face buttons (A, B, X, Y) – positions near the colored circles */}
      <StyledText x={1640} y={515}>
        {getActionForInput(gamepadLayout, JoystickInputs.Face.A)}
      </StyledText>
      <StyledText x={1640} y={475}>
        {getActionForInput(gamepadLayout, JoystickInputs.Face.B)}
      </StyledText>
      <StyledText x={1640} y={390}>
        {getActionForInput(gamepadLayout, JoystickInputs.Face.X)}
      </StyledText>
      <StyledText x={1640} y={435}>
        {getActionForInput(gamepadLayout, JoystickInputs.Face.Y)}
      </StyledText>

      {/* D-Pad */}
      <PositionedLabelBox
        x={200}
        y={480}
        alignContent='start'
        justifyItems='center'
        textAlign='center'
      >
        {getActionForInput(gamepadLayout, JoystickInputs.DPad.Up)}
      </PositionedLabelBox>

      {/* Left stick */}
      <StyledText x={825} y={900} textAnchor='middle'>
        {getActionForInput(gamepadLayout, JoystickInputs.LeftStick.Move)}
      </StyledText>
      <StyledText x={560} y={950} textAnchor='end'>
        {getActionForInput(gamepadLayout, JoystickInputs.LeftStick.Press)}
      </StyledText>

      {/* Right stick */}
      <StyledText x={1165} y={900} textAnchor='middle'>
        {getActionForInput(gamepadLayout, JoystickInputs.RightStick.Move)}
      </StyledText>
      <StyledText x={1430} y={950}>
        {getActionForInput(gamepadLayout, JoystickInputs.RightStick.Press)}
      </StyledText>

      <PositionedLabelBox x={1060} y={360}>
        {getActionForInput(gamepadLayout, JoystickInputs.System.Start)}
      </PositionedLabelBox>

      <PositionedLabelBox x={750} y={360}>
        {getActionForInput(gamepadLayout, JoystickInputs.System.Back)}
      </PositionedLabelBox>

      {/* Triggers & bumpers */}
      <PositionedLabelBox x={550} y={25}>
        {getActionForInput(gamepadLayout, JoystickInputs.Shoulder.LT)}
      </PositionedLabelBox>
      <PositionedLabelBox
        x={250}
        y={240}
        alignContent='start'
        justifyItems='center'
        textAlign='center'
      >
        {getActionForInput(gamepadLayout, JoystickInputs.Shoulder.LB)}
      </PositionedLabelBox>
      <PositionedLabelBox x={1250} y={25}>
        {getActionForInput(gamepadLayout, JoystickInputs.Shoulder.RT)}
      </PositionedLabelBox>
      <StyledText x={1570} y={265}>
        {getActionForInput(gamepadLayout, JoystickInputs.Shoulder.RB)}
      </StyledText>

      {/* Connect & Guide (center top and center middle) */}
      <StyledText x={840} y={120}>
        {t('gamePad.connect')}
      </StyledText>
      <StyledText x={970} y={385}>
        {t('gamePad.home')}
      </StyledText>
    </svg>
  );
};
